module.exports = __webpack_public_path__ + "static/media/backArrow.7f1d7c61.svg";